import React from 'react';
import ConcernMaskEffect from './ConcernMaskEffect';
import classnames from 'classnames';
import {deviceOptions} from '../../../config/utils/optionsUtils';
import DetectionsContainer from './detectionscontainer';
import ResultsContainer from './resultscontainer';
import {getActionButtonColor} from '../../../config/utils/commonUtils';
import SkinReport from './SkinReport';

export default function DetectionPreviewModal({
  type = deviceOptions[0].value,
  commonData = {},
  isHd,
  activeDetection,
  setActiveDetection,
  transformedSequenceOfCategory,
  detectionMapping,
  isShowSkinAge,
  language,
  skincareRecommendMode,
  isShowSkinHealth,
  isShowSkinType,
  scoreFormat,
  activeLang,
  recommendCategory,
  detectionDescriptionContent,
  index,
  setIndex,
  buttonText,
}) {
  const isLandscape = type === deviceOptions[1].value;
  const actionButtonColor = getActionButtonColor(commonData);

  return (
    <>
      <div className="skincaredetectionpreview-detections-mask">
        <ConcernMaskEffect
          activeDetection={activeDetection}
          transformedSequenceOfCategory={transformedSequenceOfCategory}
          detectionMapping={detectionMapping}
          isHd={isHd}
          isLandscape={isLandscape}
        />
      </div>
      <div
        className={classnames({
          'skincaredetectionpreview-info': true,
          'skincaredetectionpreview-info--landscape': isLandscape,
        })}
      >
        <div
          className={classnames({
            'skincaredetectionpreview-info-skinage': true,
            'skincaredetectionpreview-info-skinage--landscape': isLandscape,
          })}
          style={
            skincareRecommendMode && skincareRecommendMode !== 'none'
              ? {}
              : {'flex-direction': 'row'}
          }
        >
          {skincareRecommendMode && skincareRecommendMode !== 'none' && (
            <SkinReport
              actionButtonColor={actionButtonColor}
              buttonText={buttonText}
              activeLang={activeLang}
            />
          )}
          {isShowSkinAge && (
            <div className="d-flex align-items-center">
              <div>
                Skin
                <br /> Age
              </div>{' '}
              <div className="skincaredetectionpreview-info-skinage__age">
                23
              </div>
            </div>
          )}
        </div>
        <DetectionsContainer
          isHd={isHd}
          isLandscape={isLandscape}
          isShowSkinType={isShowSkinType}
          isShowSkinHealth={isShowSkinHealth}
          transformedSequenceOfCategory={transformedSequenceOfCategory}
          detectionMapping={detectionMapping}
          activeDetection={activeDetection}
          setActiveDetection={setActiveDetection}
          scoreFormat={scoreFormat}
          activeLang={activeLang}
        />
        <ResultsContainer
          skincareRecommendMode={skincareRecommendMode}
          recommendCategory={recommendCategory}
          index={index}
          setIndex={setIndex}
          activeDetection={activeDetection}
          detectionMapping={detectionMapping}
          isShowSkinAge={isShowSkinAge}
          detectionDescriptionContent={detectionDescriptionContent}
          activeLang={activeLang}
          isLandscape={isLandscape}
          commonData={commonData}
          buttonText={buttonText}
        />
      </div>
    </>
  );
}
